<span class="cx-pagination-details">
  {{ getResultsPerPage() }}
  {{
    'storeFinder.fromStoresFound'
      | cxTranslate: { count: pagination.totalResults }
  }}
</span>
